// extracted by mini-css-extract-plugin
module.exports = {"ResetPasswordPage":"ResetPasswordPage_ResetPasswordPage__3jgSt","main":"ResetPasswordPage_main__2UZpJ"};